import { LawfulPresenceAttestation, LawfulPresenceDisplayMode } from 'src/data/generated/graphql';

type Mode = LawfulPresenceDisplayMode | null | undefined;

export const LAWFUL_PRESENCE_STATE = 'GA';
export const LAWFUL_PRESENCE_ORDER = [
  LawfulPresenceAttestation.Citizen,
  LawfulPresenceAttestation.Lpr,
  LawfulPresenceAttestation.Cpa,
  LawfulPresenceAttestation.Cofa,
  LawfulPresenceAttestation.None,
];

export const asksLawfulPresence = (mode: Mode): boolean =>
  mode === LawfulPresenceDisplayMode.Conditional || mode === LawfulPresenceDisplayMode.Direct;

export const showsOptIn = (mode: Mode): boolean => mode === LawfulPresenceDisplayMode.Conditional;

export const showsStatusOptions = (mode: Mode, checkLawfulPresence?: boolean): boolean => {
  if (mode === LawfulPresenceDisplayMode.Direct) return true;
  if (mode === LawfulPresenceDisplayMode.Conditional) return !!checkLawfulPresence;
  return false;
};

export const lawfulPresenceForUpsert = (
  mode: Mode,
  member: { lawfulPresence?: LawfulPresenceAttestation | null; checkLawfulPresence?: boolean },
): LawfulPresenceAttestation | undefined =>
  showsStatusOptions(mode, member?.checkLawfulPresence)
    ? (member?.lawfulPresence ?? undefined)
    : undefined;

export const hasQualifyingStatus = (
  members: ReadonlyArray<{ lawfulPresence?: LawfulPresenceAttestation | null }> | null | undefined,
): boolean =>
  !!members?.some(
    (member) =>
      !!member?.lawfulPresence && member.lawfulPresence !== LawfulPresenceAttestation.None,
  );

export const showsLawfulPresenceNote = ({
  state,
  members,
}: {
  state?: string | null;
  members?: ReadonlyArray<{ lawfulPresence?: LawfulPresenceAttestation | null }> | null;
}): boolean => state === LAWFUL_PRESENCE_STATE && hasQualifyingStatus(members);
